var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inactive-monitoring-point" },
    [
      _c("v-text-field", {
        staticClass: "inactive-monitoring-point__search",
        attrs: {
          dense: "",
          clearable: "",
          "hide-details": "",
          "prepend-inner-icon": "fa-search",
          label: _vm.$t("field.search_label"),
          disabled: _vm.loading || _vm.candidates.length === 0,
          "data-testid": "inactive-monitoring-point-search",
        },
        model: {
          value: _vm.searchWord,
          callback: function ($$v) {
            _vm.searchWord = $$v
          },
          expression: "searchWord",
        },
      }),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center justify-center mt-4",
              attrs: { "data-testid": "inactive-monitoring-point-loading" },
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary", size: 24 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 text-body-2" }, [
                _vm._v(_vm._s(_vm.$t("msg.loading"))),
              ]),
            ],
            1
          )
        : _vm.filteredCandidates.length > 0
        ? _c(
            "v-list",
            {
              staticClass: "inactive-monitoring-point__list",
              attrs: {
                dense: "",
                "data-testid": "inactive-monitoring-point-list",
              },
            },
            _vm._l(_vm.filteredCandidates, function (candidate) {
              return _c(
                "v-list-item",
                {
                  key: candidate.id,
                  class: {
                    "inactive-monitoring-point__item--selected":
                      candidate.id === _vm.destinationId,
                  },
                  attrs: {
                    "data-testid": "inactive-monitoring-point-list-item",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select(candidate.id)
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-content",
                    { staticClass: "min-w-0" },
                    [
                      _c(
                        "v-list-item-title",
                        {
                          staticClass: "text-truncate",
                          attrs: { title: candidate.name },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(candidate.name) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm.candidates.length > 0
        ? _c(
            "p",
            {
              staticClass: "mt-3 mb-0 inactive-monitoring-point__no-candidate",
              attrs: { "data-testid": "inactive-monitoring-point-no-match" },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("msg.no_match")) + "\n  ")]
          )
        : _c(
            "p",
            {
              staticClass: "mt-3 mb-0 inactive-monitoring-point__no-candidate",
              attrs: {
                "data-testid": "inactive-monitoring-point-no-candidate",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("msg.no_candidate")) + "\n  ")]
          ),
      _vm._v(" "),
      _vm.destinationId != null
        ? _c(
            "p",
            { staticClass: "mt-1 mb-0 inactive-monitoring-point__hint" },
            [_vm._v("\n    " + _vm._s(_vm.$t("msg.hint_destination")) + "\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }